import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  FormControlLabel,
  Checkbox,
  Typography,
  Alert,
  CircularProgress,
  Box,
} from '@mui/material';
import Autocomplete from '@mui/material/Autocomplete';
import api from '../api/api';

const CatalogoForm = ({ open, onClose, mode, tabCategoria, id_catalogo, onSave }) => {
  const [referencia, setReferencia] = useState('');
  const [descripcion, setDescripcion] = useState('');
  const [costo, setCosto] = useState(0);
  const [idSubCategoria, setIdSubCategoria] = useState(null);
  const [idMarca, setIdMarca] = useState(null);
  const [esServicio, setEsServicio] = useState(false);
  const [esExento, setEsExento] = useState(false);
  const [esPermDescuento, setEsPermDescuento] = useState(false);
  const [unidadesFraccion, setUnidadesFraccion] = useState('');
  const [descripcionFraccion, setDescripcionFraccion] = useState('');
  const [subCategorias, setSubCategorias] = useState([]);
  const [marcas, setMarcas] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [userIdPet, setUserIdPet] = useState(null);
  const [userIdUsuario, setUserIdUsuario] = useState(null);

  // Decodificar token JWT para obtener id_pet y id_usuario
  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        setUserIdPet(payload.id_pet || null);
        setUserIdUsuario(payload.sub ? parseInt(payload.sub) : null);
      } catch (err) {
        setError('Error al decodificar el token: ' + err.message);
      }
    } else {
      setError('No se encontró un token de autenticación');
    }
  }, [open]);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      setError(null);
      try {
        const [subCategoriasRes, marcasRes, lastReferenciaRes] = await Promise.all([
          api.get('/sub-categorias/'),
          api.get('/marcas/'),
          api.get('/catalogos/last-referencia'),
        ]);
        setSubCategorias(subCategoriasRes.data.filter(sc => sc.habilitada === true));
          // Filtrar marcas por id_pet y habilitadas
          const filteredMarcas = userIdPet
            ? marcasRes.data.filter(marca => marca.id_pet === userIdPet && marca.habilitada === true)
            : marcasRes.data.filter(marca => marca.habilitada === true);
        setMarcas(filteredMarcas);
        if (filteredMarcas.length === 0 && userIdPet) {
          setError('No se encontraron marcas asociadas a esta veterinaria');
        }
        // Convertir referencia a string
        setReferencia(String(lastReferenciaRes.data.referencia || '1'));
      } catch (err) {
        setError('Error al cargar datos: ' + (err.response?.data?.detail || err.message));
        setReferencia('1'); // Fallback en caso de error
      } finally {
        setLoading(false);
      }
    };
    if (open && mode === 'add') {
      setDescripcion('');
      setCosto(0);
      setIdSubCategoria(null);
      setIdMarca(null);
      setEsServicio(false);
      setEsExento(false);
      setEsPermDescuento(false);
      setUnidadesFraccion('');
      setDescripcionFraccion('');
      setError(null);
      setSuccess(null);

      fetchData();
    }
  }, [open, mode, userIdPet]);

  useEffect(() => {
    if (mode === 'disable') {
      setError(null);
      setSuccess(null);
    }
  }, [mode]);

  const handleSubmitAdd = async () => {
    //if (!referencia || !descripcion || costo === '' || costo === null || idSubCategoria === null || idMarca === null) {
      if (!referencia || !descripcion || idSubCategoria === null || idMarca === null) {
      //setError('Campos obligatorios: Referencia, Descripción, Costo, Sub-categoría, Marca');
      setError('Campos obligatorios: Referencia, Descripción, Sub-categoría, Marca');
      return;
    }
    
    if (!/^\d+$/.test(referencia)) {
      setError('Referencia debe ser un número');
      return;
    }

    //const costoNum = parseFloat(costo);
    //if (isNaN(costoNum) || costoNum < 0) {
      //setError('Costo debe ser un número positivo o cero.');
      //return;
    //}
    const unidadesFraccionNum = unidadesFraccion ? parseInt(unidadesFraccion) : null;
    if (unidadesFraccion && (isNaN(unidadesFraccionNum) || unidadesFraccionNum < 0)) {
      setError('Unidades fracción debe ser un número no negativo');
      return;
    }
    if (!userIdPet || !userIdUsuario) {
      setError('Error: No se pudo obtener id_pet o id_usuario del token');
      return;
    }
    try {
      setLoading(true);
      setError(null);
      const payload = {
        id_pet: userIdPet,
        id_sub_categoria: idSubCategoria,
        id_usuario: userIdUsuario,
        id_marca: idMarca,
        referencia: String(referencia),
        descripcion,
        costo: 0,
        habilitado: true,
        es_descontinuado: false,
        es_servicio: esServicio,
        es_exento: esExento,
        es_perm_descuento: esPermDescuento,
        tab_categoria: tabCategoria,
        unidades_fraccion: unidadesFraccionNum,
        descripcion_fraccion: descripcionFraccion,
      };
      console.log('Enviando payload a POST /catalogos:', payload);
      await api.post('/catalogos/', payload);
      setSuccess('Item agregado exitosamente');
      onSave();
      onClose();
    } catch (err) {
      console.error('Error en POST /catalogos:', {
        message: err.message,
        response: err.response?.data,
        status: err.response?.status,
        payload: { id_pet: userIdPet, id_usuario: userIdUsuario, id_marca: idMarca, referencia },
      });
      let errorMessage = 'Error al agregar item: ';
      if (err.response?.data?.detail) {
        errorMessage += typeof err.response.data.detail === 'string'
          ? err.response.data.detail
          : JSON.stringify(err.response.data.detail, null, 2);
      } else if (err.response?.data) {
        errorMessage += JSON.stringify(err.response.data, null, 2);
      } else {
        errorMessage += err.message || 'Error desconocido';
      }
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmitDisable = async () => {
    try {
      setLoading(true);
      setError(null);
      const payload = {
        habilitado: false,
        es_descontinuado: true,
      };
      console.log('Enviando payload a PUT /catalogos:', payload);
      await api.put(`/catalogos/${id_catalogo}`, payload);
      setSuccess('Item deshabilitado exitosamente');
      onSave();
      onClose();
    } catch (err) {
      console.error('Error en PUT /catalogos:', {
        message: err.message,
        response: err.response?.data,
        status: err.response?.status,
      });
      let errorMessage = 'Error al deshabilitar item: ';
      if (err.response?.data?.detail) {
        errorMessage += typeof err.response.data.detail === 'string'
          ? err.response.data.detail
          : JSON.stringify(err.response.data.detail, null, 2);
      } else if (err.response?.data) {
        errorMessage += JSON.stringify(err.response.data, null, 2);
      } else {
        errorMessage += err.message || 'Error desconocido';
      }
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setReferencia('');
    setDescripcion('');
    setCosto(0);
    setIdSubCategoria(null);
    setIdMarca(null);
    setEsServicio(false);
    setEsExento(false);
    setEsPermDescuento(false);
    setUnidadesFraccion('');
    setDescripcionFraccion('');
    setError(null);
    setSuccess(null);
    setUserIdPet(null);
    setUserIdUsuario(null);
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>{mode === 'add' ? 'Agregar Item' : 'Deshabilitar Item'}</DialogTitle>

      <DialogContent>
        {/* Mensaje informativo con enlace al catálogo (solo en modo 'add') */}
        {mode === 'add' && (
          <Alert severity="info" sx={{ mb: 3 }}>
            <Typography variant="body2">
              <strong>💡 Nota:</strong> Este formulario sirve para <strong>agregar un  ítem especial para utilizar solo en los tab-tratamientos</strong> al catálogo.
              <br /><br />
              Si deseas <strong>ver todos los ítems, editarlos o deshabilitarlos</strong>, dirigete al catálogo :
            </Typography>
            <Button
              component="a"
              href="/catalogo"
              target="_blank"
              rel="noopener noreferrer"
              variant="contained"
              size="small"
              sx={{ mt: 2 }}
            >
              Ir al Catálogo Completo ↗
            </Button>
          </Alert>
        )}

        {/* Mensajes de error y éxito */}
        {error && <Alert severity="error" sx={{ mb: 2 }}><pre>{error}</pre></Alert>}
        {success && <Alert severity="success" sx={{ mb: 2 }}>{success}</Alert>}

        {loading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', my: 4 }}>
            <CircularProgress />
          </Box>
        ) : mode === 'add' ? (
          <>
            <TextField
              label="Referencia"
              value={referencia}
              fullWidth
              sx={{ mb: 2 }}
              required
              disabled
              type="text"
            />
            <TextField
              label="Descripción"
              value={descripcion}
              onChange={(e) => setDescripcion(e.target.value)}
              fullWidth
              sx={{ mb: 2 }}
              required
            />
            {/* costo
            <TextField
              label="Costo"
              value={costo}
              onChange={(e) => setCosto(e.target.value)}
              fullWidth
              type="number"
              sx={{ mb: 2 }}
              required
            />
            */}
            {/* Sub-categoría con Autocomplete */}
            <Autocomplete
              options={subCategorias}
              getOptionLabel={(option) => option.nombre_sub_categoria || ''}
              value={subCategorias.find(s => s.id_sub_categoria === idSubCategoria) || null}
              onChange={(_, newValue) => setIdSubCategoria(newValue ? newValue.id_sub_categoria : null)}
              isOptionEqualToValue={(option, value) => option.id_sub_categoria === value?.id_sub_categoria}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Sub-categoría"
                  required
                  placeholder="Buscar sub-categoría..."
                />
              )}
              sx={{ mb: 2 }}
              noOptionsText="No se encontraron sub-categorías"
            />

            {/* Marca con Autocomplete */}
            <Autocomplete
              options={marcas}
              getOptionLabel={(option) => option.nombre_marca || ''}
              value={marcas.find(m => m.id_marca === idMarca) || null}
              onChange={(_, newValue) => setIdMarca(newValue ? newValue.id_marca : null)}
              isOptionEqualToValue={(option, value) => option.id_marca === value?.id_marca}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Marca"
                  required
                  placeholder="Buscar marca..."
                />
              )}
              sx={{ mb: 2 }}
              noOptionsText="No se encontraron marcas"
            />

            <FormControlLabel
              control={<Checkbox checked={esServicio} onChange={(e) => setEsServicio(e.target.checked)} />}
              label="Es servicio"
              sx={{ mb: 1 }}
            />

            {/* CAMPOS OCULTOS POR SOLICITUD DEL USUARIO (Se mantienen comentados) */}
            {/*
            <FormControlLabel
              control={<Checkbox checked={esExento} onChange={(e) => setEsExento(e.target.checked)} />}
              label="Es exento"
              sx={{ mb: 1 }}
            />
            */}
            {/*
            <FormControlLabel
              control={<Checkbox checked={esPermDescuento} onChange={(e) => setEsPermDescuento(e.target.checked)} />}
              label="Permite descuento"
              sx={{ mb: 1 }}
            />
            */}
            {/*
            <TextField
              label="Unidades fracción"
              value={unidadesFraccion}
              onChange={(e) => setUnidadesFraccion(e.target.value)}
              fullWidth
              type="number"
              sx={{ mb: 2 }}
            />
            */}
            {/*
            <TextField
              label="Descripción fracción"
              value={descripcionFraccion}
              onChange={(e) => setDescripcionFraccion(e.target.value)}
              fullWidth
              sx={{ mb: 2 }}
            />
            */}
          </>
        ) : (
          <Typography>¿Estás seguro de deshabilitar este item? Esto lo marcará como descontinuado y no disponible.</Typography>
        )}
      </DialogContent>

      <DialogActions>
        <Button onClick={handleClose} color="secondary" disabled={loading}>Cancelar</Button>
        <Button onClick={mode === 'add' ? handleSubmitAdd : handleSubmitDisable} color="primary" disabled={loading}>
          {mode === 'add' ? 'Guardar' : 'Confirmar'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CatalogoForm;